<template>
  <div>
    <div class="main-wrapper">
      <!-- <layout-header2></layout-header2> -->
      <layout-header></layout-header>
      <breadcrumb3></breadcrumb3>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar></sidebar>
            </div>
            <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
              <loader></loader>
            </div>
            <div class="col-md-7 col-lg-8 col-xl-9" v-else>
              <div class="row ml-md-2">
                <div class="col-sm-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="profile-box">
                        <div class="row">
                          <div class="col-lg-4 doctor-profile">
                            <div class="form-group">
                              <label>Hospital</label>
                              <v-select class="mr-2" required="" label="hospital_name" placeholder="Select Hospital"
                                :disabled="this.$route.params.id" v-model="schedule_data.hospital"
                                :reduce="(option) => option.hospital" :options="service_unit_hospitals">
                              </v-select>
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <div class="form-group">
                              <label>Timing Slot Duration</label>
                              <input type="text" placeholder="In Minutes" v-model="schedule_data.slot_duration"
                                @keypress="onlyNumber" class="form-control" />
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <div class="form-group">
                              <label>Charges</label>
                              <input type="text" placeholder="In Rs" v-model="schedule_data.fees" @keypress="onlyNumber"
                                class="form-control" />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="card schedule-widget mb-0">
                              <!-- Schedule Header -->
                              <div class="schedule-header">
                                <!-- Schedule Nav -->
                                <div class="schedule-nav">
                                  <ul class="nav nav-tabs nav-justified">
                                    <li class="nav-item" style="cursor: pointer;margin-top:10px;"
                                      v-for="(item, index) in available_days" :key="index">
                                      <!-- <a class="nav-link" data-toggle="tab" :class="activeday == item ? 'active' : '' "@click="activeDay(item)">{{ abbreviateDay(item) }}</a> -->
                                      <a class="nav-link" data-toggle="tab" :class="{ 'active': activeday === item }" @click="activeDay(item)">{{ abbreviateDay(item) }}</a>
                                    </li>
                                  </ul>
                                </div>
                                <!-- /Schedule Nav -->
                              </div>
                              <!-- /Schedule Header -->

                              <!-- Schedule Content -->
                              <div class="tab-content schedule-cont">
                                <!-- Sunday Slot -->
                                <div id="slot_sunday" class="tab-pane fade" :class="activeday == 'Sunday' ? 'active show' : ''
                                  ">
                                  <h4 class="
                                      card-title
                                      d-flex
                                      justify-content-between
                                    ">
                                    <span>Time Slots</span>
                                  </h4>
                                  <p v-if="Sunday.length === 0" class="text-muted mb-3">
                                    Not Available
                                  </p>
                                  <div class="time-slots" v-for="(item, index) in Sunday" :key="index">
                                    <div class="row">
                                      <div class="m-3">
                                        <b-form-group v-if="index === 0">
                                          <label>Start Time</label>
                                        </b-form-group>
                                        <vue-timepicker style="margin-top: -20px;" class="time-slots" format="HH:mm"
                                          v-model="item.from_time"></vue-timepicker>
                                      </div>
                                      <div class="m-3">
                                        <b-form-group v-if="index === 0">
                                          <label>End Time</label>
                                        </b-form-group>
                                        <vue-timepicker style="margin-top: -20px;" format="HH:mm" class="time-slots"
                                          v-model="item.to_time"></vue-timepicker>
                                      </div>
                                      <div class="ml-3 mt-2 mb-4 mr-3">
                                        <b-form-group v-if="index === 0">
                                          <label></label>
                                        </b-form-group>
                                        <button class="btn btn-primary btn-md" @click="applyToAll(index, 'Sunday')">Apply
                                          to
                                          All Days</button>
                                      </div>
                                      <div class="mt-3 ml-4">
                                        <b-form-group v-if="index === 0">
                                          <label></label>
                                        </b-form-group>
                                        <span class="circle" style="cursor: pointer;" @click="
                                          remove_item('Sunday', index)
                                          "><i class="fa fa-times" /></span>
                                      </div>

                                    </div>
                                  </div>
                                  <div class="add-more">
                                    <a href="javascript:void(0);" @click="add_Information('Sunday')" class="add-award"><i
                                        class="fa fa-plus-circle"></i> Add
                                      More</a>
                                  </div>
                                </div>
                                <!-- /Sunday Slot -->

                                <!-- Monday Slot -->
                                <div id="slot_monday" class="tab-pane fade" :class="activeday == 'Monday' ? 'active show' : ''
                                  ">
                                  <h4 class="
                                      card-title
                                      d-flex
                                      justify-content-between
                                    ">
                                    <span>Time Slots</span>
                                  </h4>

                                  <p v-if="Monday.length === 0" class="text-muted mb-3">
                                    Not Available
                                  </p>
                                  <div class="awards-info" v-for="(item, index) in Monday" :key="index">
                                    <div class="row">
                                      <div class="m-3">
                                        <b-form-group v-if="index === 0">
                                          <label>Start Time</label>
                                        </b-form-group>
                                        <vue-timepicker style="margin-top: -20px;" class="time-slots" format="HH:mm"
                                          v-model="item.from_time"></vue-timepicker>
                                      </div>
                                      <div class="m-3">
                                        <b-form-group v-if="index === 0">
                                          <label>End Time</label>
                                        </b-form-group>
                                        <vue-timepicker style="margin-top: -20px;" format="HH:mm" class="time-slots"
                                          v-model="item.to_time"></vue-timepicker>
                                      </div>
                                      <div class="ml-3 mt-2 mb-4 mr-3">
                                        <b-form-group v-if="index === 0">
                                          <label></label>
                                        </b-form-group>
                                        <button class="btn btn-primary btn-md" @click="applyToAll(index, 'Monday')">Apply
                                          to All Days</button>
                                      </div>
                                      <div class="mt-3 ml-4">
                                        <b-form-group v-if="index === 0">
                                          <label></label>
                                        </b-form-group>
                                        <span class="circle" style="cursor: pointer;" @click="
                                          remove_item('Monday', index)
                                          "><i class="fa fa-times" /></span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="add-more">
                                    <a href="javascript:void(0);" @click="add_Information('Monday')" class="add-award"><i
                                        class="fa fa-plus-circle"></i> Add
                                      More</a>
                                  </div>
                                </div>
                                <!-- /Monday Slot -->

                                <!-- Tuesday Slot -->
                                <div id="slot_tuesday" class="tab-pane fade" :class="activeday == 'Tuesday' ? 'active show' : ''
                                  ">
                                  <h4 class="
                                      card-title
                                      d-flex
                                      justify-content-between
                                    ">
                                    <span>Time Slots</span>
                                  </h4>
                                  <p v-if="Tuesday.length === 0" class="text-muted mb-3">
                                    Not Available
                                  </p>
                                  <div class="awards-info" v-for="(item, index) in Tuesday" :key="index">
                                    <div class="row">
                                      <div class="m-3">
                                        <b-form-group v-if="index === 0">
                                          <label>Start Time</label>
                                        </b-form-group>
                                        <vue-timepicker style="margin-top: -20px;" class="time-slots" format="HH:mm"
                                          v-model="item.from_time"></vue-timepicker>
                                      </div>
                                      <div class="m-3">
                                        <b-form-group v-if="index === 0">
                                          <label>End Time</label>
                                        </b-form-group>
                                        <vue-timepicker style="margin-top: -20px;" format="HH:mm" class="time-slots"
                                          v-model="item.to_time"></vue-timepicker>
                                      </div>
                                      <div class="ml-3 mt-2 mb-4 mr-3">
                                        <b-form-group v-if="index === 0">
                                          <label></label>
                                        </b-form-group>
                                        <button class="btn btn-primary btn-md" @click="applyToAll(index, 'Tuesday')">Apply
                                          to
                                          All Days</button>
                                      </div>
                                      <div class="mt-3 ml-4">
                                        <b-form-group v-if="index === 0">
                                          <label></label>
                                        </b-form-group>
                                        <span class="circle" style="cursor: pointer;" @click="
                                          remove_item('Tuesday', index)
                                          "><i class="fa fa-times" /></span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="add-more">
                                    <a href="javascript:void(0);" @click="add_Information('Tuesday')" class="add-award"><i
                                        class="fa fa-plus-circle"></i> Add
                                      More</a>
                                  </div>
                                </div>
                                <!-- /Tuesday Slot -->

                                <!-- Wednesday Slot -->
                                <div id="slot_wednesday" class="tab-pane fade" :class="activeday == 'Wednesday'
                                  ? 'active show'
                                  : ''
                                  ">
                                  <h4 class="
                                      card-title
                                      d-flex
                                      justify-content-between
                                    ">
                                    <span>Time Slots</span>
                                  </h4>
                                  <p v-if="Wednesday.length === 0" class="text-muted mb-3">
                                    Not Available
                                  </p>
                                  <div class="awards-info" v-for="(item, index) in Wednesday" :key="index">
                                    <div class="row">
                                      <div class="m-3">
                                        <b-form-group v-if="index === 0">
                                          <label>Start Time</label>
                                        </b-form-group>
                                        <vue-timepicker style="margin-top: -20px;" class="time-slots" format="HH:mm"
                                          v-model="item.from_time"></vue-timepicker>
                                      </div>
                                      <div class="m-3">
                                        <b-form-group v-if="index === 0">
                                          <label>End Time</label>
                                        </b-form-group>
                                        <vue-timepicker style="margin-top: -20px;" format="HH:mm" class="time-slots"
                                          v-model="item.to_time"></vue-timepicker>
                                      </div>
                                      <div class="ml-3 mt-2 mb-4 mr-3">
                                        <b-form-group v-if="index === 0">
                                          <label></label>
                                        </b-form-group>
                                        <button class="btn btn-primary btn-md"
                                          @click="applyToAll(index, 'Wednesday')">Apply to
                                          All Days</button>
                                      </div>
                                      <div class="mt-3 ml-4">
                                        <b-form-group v-if="index === 0">
                                          <label></label>
                                        </b-form-group>
                                        <span class="circle" style="cursor: pointer;" @click="
                                          remove_item('Wednesday', index)
                                          "><i class="fa fa-times" /></span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="add-more">
                                    <a href="javascript:void(0);" @click="add_Information('Wednesday')"
                                      class="add-award"><i class="fa fa-plus-circle"></i> Add
                                      More</a>
                                  </div>
                                </div>
                                <!-- /Wednesday Slot -->

                                <!-- Thursday Slot -->
                                <div id="slot_thursday" class="tab-pane fade" :class="activeday == 'Thursday' ? 'active show' : ''
                                  ">
                                  <h4 class="
                                      card-title
                                      d-flex
                                      justify-content-between
                                    ">
                                    <span>Time Slots</span>
                                  </h4>
                                  <p v-if="Thursday.length === 0" class="text-muted mb-3">
                                    Not Available
                                  </p>
                                  <div class="awards-info" v-for="(item, index) in Thursday" :key="index">
                                    <div class="row">
                                      <div class="m-3">
                                        <b-form-group v-if="index === 0">
                                          <label>Start Time</label>
                                        </b-form-group>
                                        <vue-timepicker style="margin-top: -20px;" class="time-slots" format="HH:mm"
                                          v-model="item.from_time"></vue-timepicker>
                                      </div>
                                      <div class="m-3">
                                        <b-form-group v-if="index === 0">
                                          <label>End Time</label>
                                        </b-form-group>
                                        <vue-timepicker style="margin-top: -20px;" format="HH:mm" class="time-slots"
                                          v-model="item.to_time"></vue-timepicker>
                                      </div>
                                      <div class="ml-3 mt-2 mb-4 mr-3">
                                        <b-form-group v-if="index === 0">
                                          <label></label>
                                        </b-form-group>
                                        <button class="btn btn-primary btn-md"
                                          @click="applyToAll(index, 'Thursday')">Apply
                                          to
                                          All Days</button>
                                      </div>
                                      <div class="mt-3 ml-4">
                                        <b-form-group v-if="index === 0">
                                          <label></label>
                                        </b-form-group>
                                        <span class="circle" style="cursor: pointer;" @click="
                                          remove_item('Thursday', index)
                                          "><i class="fa fa-times" /></span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="add-more">
                                    <a href="javascript:void(0);" @click="add_Information('Thursday')"
                                      class="add-award"><i class="fa fa-plus-circle"></i> Add
                                      More</a>
                                  </div>
                                </div>
                                <!-- /Thursday Slot -->

                                <!-- Friday Slot -->
                                <div id="slot_friday" class="tab-pane fade" :class="activeday == 'Friday' ? 'active show' : ''
                                  ">
                                  <h4 class="
                                      card-title
                                      d-flex
                                      justify-content-between
                                    ">
                                    <span>Time Slots</span>
                                  </h4>
                                  <p v-if="Friday.length === 0" class="text-muted mb-3">
                                    Not Available
                                  </p>
                                  <div class="awards-info" v-for="(item, index) in Friday" :key="index">
                                    <div class="row">
                                      <div class="m-3">
                                        <b-form-group v-if="index === 0">
                                          <label>Start Time</label>
                                        </b-form-group>
                                        <vue-timepicker style="margin-top: -20px;" class="time-slots" format="HH:mm"
                                          v-model="item.from_time"></vue-timepicker>
                                      </div>
                                      <div class="m-3">
                                        <b-form-group v-if="index === 0">
                                          <label>End Time</label>
                                        </b-form-group>
                                        <vue-timepicker style="margin-top: -20px;" format="HH:mm" class="time-slots"
                                          v-model="item.to_time"></vue-timepicker>
                                      </div>
                                      <div class="ml-3 mt-2 mb-4 mr-3">
                                        <b-form-group v-if="index === 0">
                                          <label></label>
                                        </b-form-group>
                                        <button class="btn btn-primary btn-md" @click="applyToAll(index, 'Friday')">Apply
                                          to
                                          All Days</button>
                                      </div>
                                      <div class="mt-3 ml-4">
                                        <b-form-group v-if="index === 0">
                                          <label></label>
                                        </b-form-group>
                                        <span class="circle" style="cursor: pointer;" @click="
                                          remove_item('Friday', index)
                                          "><i class="fa fa-times" /></span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="add-more">
                                    <a href="javascript:void(0);" @click="add_Information('Friday')" class="add-award"><i
                                        class="fa fa-plus-circle"></i> Add
                                      More</a>
                                  </div>
                                </div>
                                <!-- /Friday Slot -->

                                <!-- Saturday Slot -->
                                <div id="slot_saturday" class="tab-pane fade" :class="activeday == 'Saturday' ? 'active show' : ''
                                  ">
                                  <h4 class="
                                      card-title
                                      d-flex
                                      justify-content-between
                                    ">
                                    <span>Time Slots</span>
                                  </h4>
                                  <p v-if="Saturday.length === 0" class="text-muted mb-3">
                                    Not Available
                                  </p>
                                  <div class="awards-info" v-for="(item, index) in Saturday" :key="index">
                                    <div class="row">
                                      <div class="m-3">
                                        <b-form-group v-if="index === 0">
                                          <label>Start Time</label>
                                        </b-form-group>
                                        <vue-timepicker style="margin-top: -20px;" class="time-slots" format="HH:mm"
                                          v-model="item.from_time"></vue-timepicker>
                                      </div>
                                      <div class="m-3">
                                        <b-form-group v-if="index === 0">
                                          <label>End Time</label>
                                        </b-form-group>
                                        <vue-timepicker style="margin-top: -20px;" format="HH:mm" class="time-slots"
                                          v-model="item.to_time"></vue-timepicker>
                                      </div>
                                      <div class="ml-3 mt-2 mb-4 mr-3">
                                        <b-form-group v-if="index === 0">
                                          <label></label>
                                        </b-form-group>
                                        <button class="btn btn-primary btn-md"
                                          @click="applyToAll(index, 'Saturday')">Apply to
                                          All Days</button>
                                      </div>
                                      <div class="mt-3 ml-4">
                                        <b-form-group v-if="index === 0">
                                          <label></label>
                                        </b-form-group>
                                        <span class="circle" style="cursor: pointer;" @click="
                                          remove_item('Saturday', index)
                                          "><i class="fa fa-times" /></span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="add-more">
                                    <a href="javascript:void(0);" @click="add_Information('Saturday')"
                                      class="add-award"><i class="fa fa-plus-circle"></i> Add
                                      More</a>
                                  </div>
                                </div>
                                <!-- /Saturday Slot -->
                              </div>
                              <!-- /Schedule Content -->
                            </div>

                            <div class="text-left mt-5">
                              <a class="btn btn-primary btn-sm mb-3" :class="{ 'disabled-btn': disabled }" tabindex="0"
                                @click="add_practitioner_schedule_vb()">Save Changes</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>
import patients from "../../../assets/json/doctor/mypatients.json";
const images = require.context("@/assets/img/patients", false, /\.png$|\.jpg$/);
import CommonApi from "../../../services/CommonApi";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
export default {
  mounted() {
    let user = localStorage.getItem("userInfo");
    if (!user) {
      this.$router.push({ name: 'login' })
    }
    this.get_practitioner_service_unit_hospital();
    if (this.$route.params.id) {
      this.get_schedule_details_vb(this.$route.params.id);
    }
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%",
      });
    }
  },
  components: {
    VueTimepicker,
  },
  data() {
    return {
      showspinner: true,
      disabled: true,
      patients: patients,
      service_unit_hospitals: [],
      name: this.$store.state.user.user_id,
      available_days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      activeday: "Sunday",
      schedule_data: {
        healthcare_practitioner: this.$store.state.user.user_id,
        hospital: "",
        slot_duration: "",
        fees: "",
      },
      Sunday: [],
      Monday: [],
      Tuesday: [],
      Wednesday: [],
      Thursday: [],
      Friday: [],
      Saturday: [],
    };
  },
  computed: {
  validation() {
    return this.schedule_data.hospital && this.schedule_data.slot_duration;
  },
},
  watch: {
  validation() {
    if (
      this.schedule_data.slot_duration === "" ||
      this.schedule_data.hospital === "" ||
      this.schedule_data.hospital === null
    ) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
  },
},
  methods: {

    abbreviateDay(fullDayName) {
    const daysMap = {
      Sunday: 'Sun',
      Monday: 'Mon',
      Tuesday: 'Tue',
      Wednesday: 'Wed',
      Thursday: 'Thu',
      Friday: 'Fri',
      Saturday: 'Sat',
    };

    return daysMap[fullDayName] || fullDayName;
  },

    async applyToAll(index, sourceDay) {
      const sourceSlots = this[sourceDay];

      this.available_days.forEach((day) => {
        if (day !== sourceDay) {
          this[day] = [...sourceSlots]; // Copy slots from the source day to other days
        }
      });

      // Make API call here with data from Monday to Sunday
      await this.saveDataToAPI();
    },

    async saveDataToAPI() {
      var data = new FormData();
      let slot = {};
      const schedule_data = {
        healthcare_practitioner: this.schedule_data.healthcare_practitioner,
        hospital: this.schedule_data.hospital,
        slot_duration: this.schedule_data.slot_duration,
        fees: this.schedule_data.fees,
      };

      // Prepare slot data for each day
      this.available_days.forEach((day) => {
        slot[day] = this[day].map(item => ({
          from_time: this.formatTimeForSending(item.from_time),
          to_time: this.formatTimeForSending(item.to_time),
        }));
      });

      data.append('data', JSON.stringify(schedule_data));
      data.append('time_slots', JSON.stringify(slot));

      try {
        const res = await CommonApi.post_data('sahaj.appointment.add_practitioner_schedule_vb', data);

        if (res && res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          }).then(() => {
            window.location.reload();
          });
        }
      } catch (error) {
        console.error('Error while making API call:', error);
        // Handle error appropriately
      }
    },

    formatTimeForSending(time) {
      // Assuming time is in "hh:mm" format
      return time + ':00';
    },


    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    //Allow User to type number only
    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    activeDay(day) {
      this.activeday = day;
    },

    /* Add Update practitioner_schedule */
    add_practitioner_schedule_vb() {
      if (!this.disabled) {
        this.$swal({
          text: "Adding Schedule",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        this.disabled = true;
        var data = new FormData();
        let slot = {};
        slot.Sunday = this.Sunday.map(item => ({
          from_time: this.formatTimeForSending(item.from_time),
          to_time: this.formatTimeForSending(item.to_time),
        }));
        slot.Monday = this.Monday.map(item => ({
          from_time: this.formatTimeForSending(item.from_time),
          to_time: this.formatTimeForSending(item.to_time),
        }));
        slot.Tuesday = this.Tuesday.map(item => ({
          from_time: this.formatTimeForSending(item.from_time),
          to_time: this.formatTimeForSending(item.to_time),
        }));
        slot.Wednesday = this.Wednesday.map(item => ({
          from_time: this.formatTimeForSending(item.from_time),
          to_time: this.formatTimeForSending(item.to_time),
        }));
        slot.Thursday = this.Thursday.map(item => ({
          from_time: this.formatTimeForSending(item.from_time),
          to_time: this.formatTimeForSending(item.to_time),
        }));
        slot.Friday = this.Friday.map(item => ({
          from_time: this.formatTimeForSending(item.from_time),
          to_time: this.formatTimeForSending(item.to_time),
        }));
        slot.Saturday = this.Saturday.map(item => ({
          from_time: this.formatTimeForSending(item.from_time),
          to_time: this.formatTimeForSending(item.to_time),
        }));
        data.append("data", JSON.stringify(this.schedule_data));
        data.append("time_slots", JSON.stringify(slot));
        CommonApi.post_data(
          "sahaj.appointment.add_practitioner_schedule_vb",
          data
        ).then((res) => {
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            }).then(() => {
              this.$router.push(`/doctor/schedule-timings`);
            });
    
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            }).then(() => {
              window.location.reload();
            });
          }
        });
      }
    },

    /* Add Any Information */
    add_Information(type) {
      if (type === "Sunday") {
        this.Sunday.push({ from_time: "", to_time: "" });
      } else if (type === "Monday") {
        this.Monday.push({ from_time: "", to_time: "" });
      } else if (type === "Tuesday") {
        this.Tuesday.push({ from_time: "", to_time: "" });
      } else if (type === "Wednesday") {
        this.Wednesday.push({ from_time: "", to_time: "" });
      } else if (type === "Thursday") {
        this.Thursday.push({ from_time: "", to_time: "" });
      } else if (type === "Friday") {
        this.Friday.push({ from_time: "", to_time: "" });
      } else if (type === "Saturday") {
        this.Saturday.push({ from_time: "", to_time: "" });
      }
    },

    /* Remove Any Information */
    remove_item(type, id) {
      if (type === "Sunday") {
        this.Sunday.splice(id, 1);
      } else if (type === "Monday") {
        this.Monday.splice(id, 1);
      } else if (type === "Tuesday") {
        this.Tuesday.splice(id, 1);
      } else if (type === "Wednesday") {
        this.Wednesday.splice(id, 1);
      } else if (type === "Thursday") {
        this.Thursday.splice(id, 1);
      } else if (type === "Friday") {
        this.Friday.splice(id, 1);
      } else if (type === "Saturday") {
        this.Saturday.splice(id, 1);
      }
    },

    /* Get Service Unit Hospital */
    async get_practitioner_service_unit_hospital() {
      const params = new URLSearchParams();
      params.append("practitioner", this.name);
      await CommonApi.get_data(
        "sahaj.appointment.get_practitioner_service_unit_hospital_to_add_schedules",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.service_unit_hospitals = res.data;
        }
      });
    },

    /* Get Schedule Details */
    async get_schedule_details_vb(id) {
      const params = new URLSearchParams();
      params.append("schedule_id", id);
      await CommonApi.get_data(
        "sahaj.appointment.get_schedule_details_vb",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.schedule_data.healthcare_practitioner =
            res.data.healthcare_practitioner;
          this.schedule_data.hospital = res.data.hospital;
          this.schedule_data.slot_duration = res.data.slot_duration;
          this.schedule_data.fees = res.data.fees;

          if (res.data.schedule_slots.Sunday.length) {
            this.Sunday = [];
            res.data.schedule_slots.Sunday.map((item) =>
              this.Sunday.push({
                from_time: item.from_time,
                to_time: item.to_time,
              })
            );
          }

          if (res.data.schedule_slots.Monday.length) {
            this.Monday = [];
            res.data.schedule_slots.Monday.map((item) =>
              this.Monday.push({
                from_time: item.from_time,
                to_time: item.to_time,
              })
            );
          }

          if (res.data.schedule_slots.Tuesday.length) {
            this.Tuesday = [];
            res.data.schedule_slots.Tuesday.map((item) =>
              this.Tuesday.push({
                from_time: item.from_time,
                to_time: item.to_time,
              })
            );
          }

          if (res.data.schedule_slots.Wednesday.length) {
            this.Wednesday = [];
            res.data.schedule_slots.Wednesday.map((item) =>
              this.Wednesday.push({
                from_time: item.from_time,
                to_time: item.to_time,
              })
            );
          }

          if (res.data.schedule_slots.Thursday.length) {
            this.Thursday = [];
            res.data.schedule_slots.Thursday.map((item) =>
              this.Thursday.push({
                from_time: item.from_time,
                to_time: item.to_time,
              })
            );
          }

          if (res.data.schedule_slots.Friday.length) {
            this.Friday = [];
            res.data.schedule_slots.Friday.map((item) =>
              this.Friday.push({
                from_time: item.from_time,
                to_time: item.to_time,
              })
            );
          }

          if (res.data.schedule_slots.Saturday.length) {
            this.Saturday = [];
            res.data.schedule_slots.Saturday.map((item) =>
              this.Saturday.push({
                from_time: item.from_time,
                to_time: item.to_time,
              })
            );
          }
        }
      });
    },
  },
};
</script>
<style>
.time-slots .display-time {
  width: 150px !important;
}

.time-slots .clear-btn {
  display: none !important;
}

.disabled-btn {
  background-color: #DCDCDC;
  cursor: not-allowed;
  pointer-events: none;
  border: #DCDCDC;
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/NewScheduleTimings.vue